import { Channel as ReturnChannel } from "@redotech/redo-model/return";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ChannelState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/channel";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

const CHANNEL_OPTIONS = [
  { value: ReturnChannel.WEB, label: "Web" },
  { value: ReturnChannel.POINT_OF_SALE, label: "Point of Sale" },
];

export const ChannelDetails = memo(function ChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ChannelState>) {
  const channelOptions: RedoListItem<ReturnChannel>[] = useMemo(
    () =>
      CHANNEL_OPTIONS.map((option) => ({
        id: option.value,
        value: option.value,
        type: "text" as const,
        text: option.label,
      })),
    [],
  );

  const selectedChannel = state
    ? channelOptions.find((option) => option.value === state)
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label="Channel"
      options={channelOptions}
      optionSelected={({ item }) => setState(item.value)}
      placeholder="Select channel..."
      selectedItem={selectedChannel}
      size="xs"
    />
  );
});
